import React, { Component } from 'react';
import styled from 'styled-components';

export default class Box extends Component {
  render() {
    return (
      <BoxContainer>
        <BoxSection>
          <BoxImageContainer  width={this.props.width}>
            <Image src={this.props.src} />
          </BoxImageContainer>
        </BoxSection>
        <BoxSection>
          <BoxText>{this.props.text}</BoxText>
        </BoxSection>
      </BoxContainer>
    );
  }
}

const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 270px;
  height: 100px;
  justify-content: space-between;
`;

const BoxSection = styled.div`
  display: flex;
  justify-content: center;
`;

const BoxText = styled.div`
  font-size: 15px;
  text-align: center;
`;

const BoxImageContainer = styled.div`
  width: ${props => props.width};
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/Overview/Box.js